import { RegimenLaboralHEDTO } from "components/DirectivoUnidad/Horas Extras/PlanificacionHE/TypesPlanificacionHE"
import { number } from "yargs"

export type DetalleProyeccion = {
    idPeriodoProyeccion: number,
    fechaInicioProyeccion: string
    fechaFinProyeccion: string
    fechaInicioPresupuesto: string | null
    fechaFinPresupuesto: string | null
    fechaInicioExtrProyeccion: string | null
    fechaFinExtrProyeccion: string | null
}

export type DetalleProyeccionUnidadRegimen = {
    idRegimenLaboral: number,
    horasSuplementarias: number,
    horasExtraordinarias: number | null,
    totalHoras: number | null,
    valorProyeccionHSupl: number | null,
    valorProyeccionHExtr: number | null,
    valorTotalProyeccion: number | null,
    nroServidoresProyectados: number
}

export type ValorAsignadoRegimen = {
    idRegimenLaboral: number,
    presupuestoSuplementarias: number,
    presupuestoExtraordinarias: number
    presupuestosignado: number

}

export type UnidadesProyeccion = {
    idEstructuraOrganica: number,
    nombreEstructura: string,
    articuloEstructura: string,
    detalleProyeccionRegimen: DetalleProyeccionUnidadRegimen[],
    presupuestoProyectado: number | null,
    presupuestoEjecutado: number | null,
    presupuestoAsignado: number | null,
    estado: string,
    estadoString: string,
    detalleSolicitudReverso: DetalleSolicitudReverso | null
}

export type DetalleSolicitudReverso =
    {
        idSolicitudReverso: number
        motivoReverso: string
        estado: string
        estadoString: string
        fechaSolicitud: Date
    }

export type InformacionGeneralProyeccionTH = {
    anio: number,
    listadoRegimenLaborales: RegimenLaboralHEDTO[],
    listadoInformacionProyeccionUnidades: UnidadesProyeccion[],
    informacionProyeccion: DetalleProyeccion | undefined,
    totalProyeccionUnidades: ProyeccionTotal | null


}

export type ProyeccionTotal = {
    valorTotalizadoRegimen: ProyeccionRegimenTotalUnidad[],
    valorTotalProyeccionActual: number | null,
    valorTotalEjecutadoAnioAnterior: number | null,
    valorTotalPresupuestoAsignado: number | null,
    valorTotalPresupuestoModificado: number | null,
    valorTotalPresupuestoCodificado: number | null,
    nroServidoresProyectados: number
}

export type ProyeccionRegimenTotalUnidad = {
    idRegimenLaboral: number,
    nroHoras: number | null,
    valorHoras: number | null,
    nombreRegimen: string,
    siglasRegimen: string,
    porcentajeProyectado: number | null,
    nroServidoresProyectados: number
}

export type PostReversoUnidadProyeccion = {
    idEstructuraOrganica: number,
    idHeProyUnidad: number
}

export type ReversarUnidadProyeccionHEDTO = {
    unidades: number[]
    motivo: string
}

export type AtenderSolicitudReverso = {
    idSolicitudReverso: number,
    tipoAccion: 1 | 2 // 1 significa APROBAR, 2 significa NEGAR
}

export const ESTADO_REVERSADO_TH = "RT"
export const ESTADO_SOLICITADO_REVERSO_A_TH = "SR"
export const ESTADO_ENVIADO_A_TH = "ET"
export const ESTADO_ENVIADO_A_GPE = "EG"
export const ESTADO_ASIGNADO_PRESUPUESTO = "AP"